import { combineReducers } from 'redux';
import bidDetailsReducer from './bidDetailsReducer';
import categoryDetailsReducer from './categoryDetailsReducer';
import invoiceDetailsReducer from './invoiceDetailsReducer';
import invoiceListByOrderIdReducer from './invoiceListByOrderIdReducer';
import orderDetailsReducer from './orderDetailsReducer';
import staffDetailsReducer from './staffDetailsReducer';
import userDetailsReducer from './userDetailsReducer';
import vendorDetailsReducer from './vendorDetailsReducer';
import uiReducer from './uiSlice';

const appReducer = combineReducers({
  bidDetailsReducer,
  categoryDetailsReducer,
  invoiceDetailsReducer,
  invoiceListByOrderIdReducer,
  orderDetailsReducer,
  staffDetailsReducer,
  userDetailsReducer,
  vendorDetailsReducer,
  ui: uiReducer,
});

// const rootReducer = (state, action) => {
//   if (action.type === 'USER_LOGOUT') {
//     return appReducer(undefined, action);
//   }
//   return appReducer(state, action);
// };

// export default rootReducer;
export default appReducer;
